<script setup lang="ts">
  import {useI18n} from 'vue-i18n';
  import useCpBem from '~/composables/useCpBem';
  import CpSectionHeader from '~/components/cp/CpSection/CpSectionHeader/CpSectionHeader.vue';
  import CpCardReview from '~/components/cp/CpCardReview/CpCardReview.vue';
  import type {IProductReview} from '~/types';

  defineProps<{
    type: 'MostRecent'|'MostUseful'
    reviews: Array<IProductReview>
    af?: boolean
    isLogged?: boolean
  }>();
  const {t} = useI18n();
  const {bm, e, em} = useCpBem('cp-card-review-classification');
</script>

<template>
    <div v-if="reviews.length > 0" :class="bm({ af })">
        <CpSectionHeader
            :class="e('title')"
            :title="type==='MostRecent' ? t('recent') : t('useful')"
            type="h3-fake"
            :af="af"
        />
        <CpCardReview
            v-for="(review, index) in reviews"
            :id="review.id"
            :key="index"
            :class="em('card',{lastItem: index === reviews.length - 1})"
            :rate="review.rating"
            :image="review.userPic"
            :title="review.title"
            :body="review.body"
            :user-name="review.userName"
            :date="review.date"
            :verified="review.verifiedPurchase"
            :all-reviews="false"
            :dislikes-count="review.negativeVotes"
            :likes-count="review.positiveVotes"
            :af="af"
            pdp
            :review-data="review"
            :is-logged="isLogged"
            :show-border-bottom="index !== reviews.length - 1"
        />
    </div>
</template>

<style scoped lang="scss">
  .cp-card-review-classification {
    display: flex;
    flex-direction: column;
    border: 1px solid var(--color-neutral-extra-light);
    border-radius: 8px;
    &--af {
      background-color: var(--color-neutral);
      border: 1px solid var(--color-neutral-light);
    }

    &__title {
      border-top: none;
    }
  }
</style>

<i18n locale="es-US" lang="yaml">
  useful: "Las más útiles"
  recent: "Las más recientes"
</i18n>
